import { getHeaderPatternContrast, CONTRASTS } from './colorUtils';
const DARK_SUFFIX = '_dark.png';
const LIGHT_SUFFIX = '_light.png';
const patternImages = require.context('bender-url!TemplateAssets/img/hs_kb_template_images/patterns', true);
const getPublishedPatternURL = fileName => `https:${patternImages(`./${fileName}`)}`;
const patternNames = ['header_pattern_confetti', 'header_pattern_zigzag', 'header_pattern_dots', 'header_pattern_waves', 'header_pattern_circles'];
const isDarkPriorityPattern = patternUrl => {
  return patternUrl && (patternUrl.includes('confetti') || patternUrl.includes('circles'));
};
export const PATTERNS = patternNames.map(patternName => {
  let value = '';
  try {
    const darkUrl = getPublishedPatternURL(`${patternName}${DARK_SUFFIX}`);
    if (darkUrl.includes('TemplateAssets/static/')) {
      throw new Error(`Pattern image resolved to local asset URL. Don't run TemplateAssets locally.`);
    }
    value = darkUrl;
  } catch (err) {
    console.warn(`Error resolving header pattern option ${patternName}: ${err.message}`);
  }
  return {
    patternName,
    value
  };
}).filter(({
  value
}) => value.length > 0);
export function getPatternUrl(currentPatternUrl, color) {
  const contrast = getHeaderPatternContrast(color, isDarkPriorityPattern(currentPatternUrl));
  if (currentPatternUrl && currentPatternUrl.endsWith(DARK_SUFFIX) && contrast === CONTRASTS.LIGHT) {
    return currentPatternUrl.replace(DARK_SUFFIX, LIGHT_SUFFIX);
  }
  if (currentPatternUrl && currentPatternUrl.endsWith(LIGHT_SUFFIX) && contrast === CONTRASTS.DARK) {
    return currentPatternUrl.replace(LIGHT_SUFFIX, DARK_SUFFIX);
  }
  return currentPatternUrl;
}